import { MessageSquare } from 'lucide-react'
import { Link, useLocation } from 'react-router'

import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar'
import { SidebarCountBadge } from '@/components/ui/sidebar-count-badge'
import { useScopePrefix } from '@/domains/setup'

import { useMessagingUnreadCount } from './use-unread-count'

/** sidebar messages entry. links to /messages and mirrors BellButton so the
 * two header buttons read as a matched pair (collapsed dot, expanded pill).
 */
export function MessagesButton() {
  const prefix = useScopePrefix()
  const href = `${prefix}/messages`
  const location = useLocation()
  const unreadQuery = useMessagingUnreadCount()
  const count = unreadQuery.data?.count ?? 0
  const hasUnread = count > 0
  const isActive = location.pathname.startsWith(href)

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        tooltip={hasUnread ? `Messages (${count})` : 'Messages'}
        isActive={isActive || undefined}
      >
        <Link to={href}>
          <span className='relative inline-flex'>
            <MessageSquare />
            <SidebarCountBadge count={count} variant='dot' />
          </span>
          <span>Messages</span>
          <SidebarCountBadge count={count} variant='pill' />
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  )
}
